import { motion } from 'framer-motion';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Animations } from '../../utils/animations';
import { PrimarySectionStyles } from '../../styles/styles';

//fontawesome
library.add(fab, faExternalLinkSquareAlt);

type Prop = {
  title: string;
  githubLink: string;
  liveLink: string;
  texts: string[];
};

const PrimarySection = (props: Prop) => {
  const { title, githubLink, liveLink, texts } = props;
  const { transition, textReveal, opacityReveal } = Animations();

  return (
    <PrimarySectionStyles data-scroll-section>
      <div className="content">
        <div className="title-wrapper">
          <motion.h1
            variants={textReveal}
            initial="initial"
            animate="animate"
            transition={{ ...transition, duration: 2, delay: 4 }}
            className="title">
            {title}
          </motion.h1>
          <motion.div
            initial={{ x: '-120%' }}
            animate={{ x: '0%' }}
            transition={{ ...transition, duration: 2, delay: 4.4 }}
            className="underline"></motion.div>
        </div>
        <motion.div
          variants={opacityReveal}
          initial="initial"
          animate="animate"
          transition={{ ...transition, duration: 2, delay: 4.6 }}
          className="links">
          <a
            className="tap-highlight-transparent"
            href={githubLink}
            target="_blank"
            rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'github']} />
          </a>
          <a
            className="tap-highlight-transparent"
            href={liveLink}
            target="_blank"
            rel="noreferrer">
            <FontAwesomeIcon icon={['fas', 'external-link-square-alt']} />
          </a>
        </motion.div>
        {texts.map((text, index) => {
          return (
            <motion.p
              variants={opacityReveal}
              initial="initial"
              animate="animate"
              transition={{ ...transition, duration: 2, delay: 4.8 }}
              className="text font-poppins text-[#919191]"
              key={index}>
              {text}
            </motion.p>
          );
        })}
      </div>
    </PrimarySectionStyles>
  );
};

export default PrimarySection;
